<template>
    <div class="py-4">
        <header class="pb-4">
            <div class="container-fluid">
                <div class="row align-items-end">
                    <div class="col-sm col-12">
                        <h1 class="h2 ls-tight">Ajustes Generales</h1>
                    </div>
                    <div class="col-sm-auto col-12 mt-4 mt-sm-0">
                        <div class="hstack gap-2 justify-content-sm-end">
                            <button @click="SAVE()" type="button" class="btn btn-h btn-success px-3">
                                <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span v-else>Guardar cambios</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="col px-0 mb-2">
                                <h5 class="me-auto">Datos Generales</h5>
                            </div>
                            <div class="card mb-4">
                                <div class="card-body px-0 py-2">
                                    <div class="row">
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Nombre</small>
                                            <input type="text" v-model="data.name" class="form-control form-control-sm" :class="errors.name ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.name" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Nombre comercial</small>
                                            <input type="text" v-model="data.tradename" class="form-control form-control-sm" :class="errors.tradename ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.tradename" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Nombre internacional</small>
                                            <input type="text" v-model="data.international_name" class="form-control form-control-sm" :class="errors.international_name ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.international_name" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Cédula Jurídica</small>
                                            <input type="text" v-model="data.legal_id" class="form-control form-control-sm" :class="errors.legal_id ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.legal_id" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Sitio web</small>
                                            <input type="text" v-model="data.site" class="form-control form-control-sm" :class="errors.site ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.site" :key="index">{{ error }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="col px-0 mb-2">
                                <h5 class="me-auto">Tipo de cambio</h5>
                            </div>
                            <div class="card mb-3">
                                <div class="card-body px-0 py-2">
                                    <div class="row">
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Tipo de cambio</small>
                                            <input type="text" v-model="data.exchange_rate" class="form-control form-control-sm" :class="errors.exchange_rate ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.exchange_rate" :key="index">{{ error }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12"></div>
                        <div class="col-lg-6">
                            <div class="col px-0 mb-2">
                                <h5 class="me-auto">Datos Costa Rica</h5>
                            </div>
                            <div class="card mb-4">
                                <div class="card-body px-0 py-2">
                                    <div class="row">
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico</small>
                                            <input type="text" class="form-control form-control-sm" v-model="data.email" :class="errors.email ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.email" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico soporte</small>
                                            <input type="text" class="form-control form-control-sm" v-model="data.email_suport" :class="errors.email_suport ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.email_suport" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico información</small>
                                            <input type="text" class="form-control form-control-sm" v-model="data.email_info" :class="errors.email_info ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.email_info" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Dirección</small>
                                            <textarea v-model="data.address" class="form-control form-control-sm" :class="errors.address ? 'is-invalid' : ''"></textarea>
                                            <small class="invalid-feedback" v-for="(error, index) in errors.address" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Teléfono</small>
                                            <input type="text" v-model="data.phone" @keypress="NUMBER" class="form-control form-control-sm" :class="errors.phone ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.phone" :key="index">{{ error }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="col px-0 mb-2">
                                <h5 class="me-auto">Datos Miami</h5>
                            </div>
                            <div class="card mb-4">
                                <div class="card-body px-0 py-2">
                                    <div class="row">
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico</small>
                                            <input type="text" class="form-control form-control-sm" v-model="data.email_miami" :class="errors.email_miami ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.email_miami" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico soporte</small>
                                            <input type="text" class="form-control form-control-sm" v-model="data.email_suport_miami" :class="errors.email_suport_miami ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.email_suport_miami" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico información</small>
                                            <input type="text" class="form-control form-control-sm" v-model="data.email_info_miami" :class="errors.email_info_miami ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.email_info_miami" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Dirección</small>
                                            <textarea v-model="data.address_miami" class="form-control form-control-sm" :class="errors.address_miami ? 'is-invalid' : ''"></textarea>
                                            <small class="invalid-feedback" v-for="(error, index) in errors.address_miami" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Teléfono</small>
                                            <input type="text" v-model="data.phone_miami" @keypress="NUMBER" class="form-control form-control-sm" :class="errors.phone_miami ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.phone_miami" :key="index">{{ error }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="col px-0 mb-2">
                                <h5 class="me-auto">Factura electrónica</h5>
                            </div>
                            <div class="card mb-3">
                                <div class="card-body px-0 py-2">
                                    <div class="row">
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Tarifa</small>
                                            <input type="text" v-model="data.tarifa" class="form-control form-control-sm" :class="errors.tarifa ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.tarifa" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico emisor</small>
                                            <input type="text" v-model="data.emisor_mail" class="form-control form-control-sm" :class="errors.emisor_mail ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.emisor_mail" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Nombre emisor</small>
                                            <input type="text" class="form-control form-control-sm" v-model="data.emisor_name" :class="errors.emisor_name ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.emisor_name" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo electrónico reporta fel</small>
                                            <input type="text" v-model="data.report_fel_email" class="form-control form-control-sm" :class="errors.report_fel_email ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.report_fel_email" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Nombre reporta fel</small>
                                            <input type="text" v-model="data.report_fel_name" class="form-control form-control-sm" :class="errors.report_fel_name ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.report_fel_name" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Correo de soporte</small>
                                            <input type="text" v-model="data.support_email" @keypress="NUMBER" class="form-control form-control-sm" :class="errors.support_email ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.support_email" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-12 mb-2">
                                            <small class="input-title">Nombre de soporte</small>
                                            <input type="text" v-model="data.support_name" class="form-control form-control-sm" :class="errors.support_name ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.support_name" :key="index">{{ error }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="col px-0 mb-2">
                                <h5 class="me-auto">Redes sociales</h5>
                            </div>
                            <div class="card mb-3">
                                <div class="card-body px-0 py-2">
                                    <div class="row">
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Facebook</small>
                                            <input type="text" v-model="data.facebook" class="form-control form-control-sm" :class="errors.facebook ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.facebook" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Instagram</small>
                                            <input type="text" v-model="data.instagram" class="form-control form-control-sm" :class="errors.instagram ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.instagram" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Twiter</small>
                                            <input type="text" v-model="data.twiter" class="form-control form-control-sm" :class="errors.twiter ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.twiter" :key="index">{{ error }}</small>
                                        </div>
                                        <div class="col-lg-6 mb-2">
                                            <small class="input-title">Linkedin</small>
                                            <input type="text" v-model="data.linkedin" class="form-control form-control-sm" :class="errors.linkedin ? 'is-invalid' : ''">
                                            <small class="invalid-feedback" v-for="(error, index) in errors.linkedin" :key="index">{{ error }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
export default {
    data(){
        return {
            data: {},
            errors: {},
            count: 0,
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/config', method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
        },
        SAVE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/config', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>
